import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Button, FloatingInput } from '@piplapps/pipl-ui';
import styles from './EditProfileModal.module.less';
import { UsersActions } from '../../../../Redux/modules/users/actions';
import { UsersSelectors } from '../../../../Redux/modules/users/selectors';
import LoadingButton from '../../../../Components/LoadingButton';
import AnalyticsHandler from '../../../../Utils/AnalyticsHandler/AnalyticsHandler';
import AnalyticsEventNames from '../../../../Utils/AnalyticsHandler/AnalyticsEventNames';

const editProfileModal = (props) => {
  // eslint-disable-next-line camelcase
  const { id, first_name, last_name, email } = props.userData;

  const validate = (values) => {
    const errors = {};
    for (const value in values) {
      if (values[value] === '' || !values[value]) {
        errors[value] = gettext('This field is required');
      }
    }

    return errors;
  };

  const formik = useFormik(
    {
      initialValues: {
        // eslint-disable-next-line camelcase
        firstName: first_name || '',
        // eslint-disable-next-line camelcase
        lastName: last_name || '',
      },
      validate,
      onSubmit: (values) => {
        props.onEditProfile({
          firstName: values.firstName,
          lastName: values.lastName,
          userId: id,
        });
      },
    },
    [id],
  );
  const [error, setError] = useState(false);

  useEffect(() => {
    setError(props.modalError);
  }, [props.modalError]);

  return (
    <form onSubmit={formik.handleSubmit} id="edit-user-profile-form">
      <div className={styles.modalContainer}>
        <span tabIndex={0} role="button" className={styles.close} onClick={() => props.clickedCloseModalButton()}>
          &times;
        </span>
        <div className={styles.header}>{gettext("Update user's name")}</div>
        <div className={styles.email}>
          {gettext('Email: ')}
          <strong>{`${email}`}</strong>
        </div>
        <div className={styles.inputWrapper}>
          <FloatingInput
            className={styles.textInput}
            type="text"
            name="firstName"
            touched={formik.touched}
            onBlur={formik.handleBlur}
            errors={formik.errors}
            onChange={formik.handleChange}
            value={formik.values.firstName}
            placeholder={gettext('First Name')}
            forcedError={formik.touched.firstName && formik.errors.firstName ? formik.errors.firstName : null}
            staticColor
          />
        </div>
        <div className={styles.inputWrapper}>
          <FloatingInput
            className={styles.textInput}
            type="text"
            name="lastName"
            touched={formik.touched}
            onBlur={formik.handleBlur}
            errors={formik.errors}
            onChange={formik.handleChange}
            value={formik.values.lastName}
            placeholder={gettext('Last name')}
            staticColor
            forcedError={formik.touched.lastName && formik.errors.lastName ? formik.errors.lastName : null}
          />
        </div>

        <div className={styles.buttonContainer}>
          <div className={styles.buttonUpdate}>
            <AnalyticsHandler
              eventName={AnalyticsEventNames.EDIT_USER_NAME}
              eventData={{
                manipulatedUser: id,
                manipulatedUserEmail: email,
                firstName: formik.values.firstName,
                lastName: formik.values.lastName,
                previousFirstName: first_name,
                previousLastName: last_name,
              }}
            >
              <LoadingButton
                buttonClass="primary-blue"
                type="submit"
                text={gettext('Update')}
                width="39%"
                loadingText={gettext('Updating')}
                disabled={formik.values.firstName === first_name && formik.values.lastName === last_name}
                id="submit-button"
              />
            </AnalyticsHandler>
          </div>
          <div className={styles.buttonCancel}>
            <Button
              buttonClass="secondary-blue"
              onClick={() => props.clickedCloseModalButton()}
              text={gettext('Cancel')}
              id="cancel-button"
            />
          </div>
        </div>
      </div>
    </form>
  );
};

editProfileModal.propTypes = {
  userData: PropTypes.object,
  onEditProfile: PropTypes.func,
  modalError: PropTypes.bool,
  modalErrorMessage: PropTypes.string,
  clickedCloseModalButton: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {
    modalError: UsersSelectors.modalErrorSelector(state),
    modalErrorMessage: UsersSelectors.modalErrorMessageSelector(state),
  };
};

const mapDispatchToProps = {
  onEditProfile: UsersActions.editProfile,
  clickedCloseModalButton: UsersActions.clickedCloseModalButton,
};

export default connect(mapStateToProps, mapDispatchToProps)(editProfileModal);
